import type { GetFhirCapabilityStatementResponse } from '../../contracts/types';
import { http } from './ehrHttp';

/** Returns the FHIR R4 CapabilityStatement for the user's connected EHR. */
export const getFhirCapabilityStatement = () => {
  return http().get<GetFhirCapabilityStatementResponse>('/integrations/fhir/metadata');
};
